var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"company-value","space":"56"}},[_c('v-container',[_c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('base-business-info',{attrs:{"title":"NILAI PERUSAHAAN (G.R.A.V.I.T.A.S.I)"}}),_c('v-img',{attrs:{"src":require('@/assets/company-value.png')}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }